var render = function render(){var _vm=this,_c=_vm._self._c;return (!(_vm.blackRoutePath.some((nav, index) => nav === _vm.$route.path)))?_c('keep-alive',[_c('router-view')],1):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }